//ダッシュボード表示要素の子項目
import React from 'react';
import { Childs, Contents } from '../types/DashboardIndex';
import DashboardIndexContent from '../molecules/DashboardIndexContent';

type Props = {
  childs: Childs[];
  contents: Contents[];
  parent_id: number;
};

const DashboardIndexChild: React.FC<Props> = ({ childs, parent_id, contents }) => {
  return (
    <div>
      {childs.map((child, index) => {
        return (
          child.parent_id === parent_id && (
            <fieldset className="dashbord_border mx-2 my-3" key={index}>
              <div className="row px-5">
                <div className="col-lg-7 ms-3">状態</div>
                <div className="col-sm-2 ms-3 text-center">案件数</div>
                <div className="col-sm-2 ms-3 text-center">滞留数</div>
              </div>
              <legend className="bold w-auto px-3 ms-3">{child.group_name}</legend>
              <DashboardIndexContent contents={contents} child_id={child.child_id} />
            </fieldset>
          )
        );
      })}
    </div>
  );
};
export default DashboardIndexChild;
